import { useEffect, useState } from 'react';
import { apiFetch } from '../auth/apiClient';

// Match the case-wide decision picker, including historical/manual plans.
// An empty draft plan is not evidence of a funding/support decision.
export function appealQuickAction(entry, choices) {
  if (entry?.hasActiveAppeal) {
    return entry.activeAppeals?.length ? { id: 'appeal-decision', text: 'View appeal' } : null;
  }
  const plans = choices?.plans || [];
  const hasDecision = choices?.decisions?.length > 0 || plans.some(plan =>
    ['active', 'closed'].includes(plan.status) || choices?.interventions?.some(item =>
      String(item.actionPlanId) === String(plan.id) &&
      ['approved', 'in_progress', 'suspended', 'completed'].includes(item.status)
    )
  );
  return hasDecision ? { id: 'appeal-decision', text: 'Lodge appeal' } : null;
}

export default function useAppealQuickAction(caseId) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    if (!caseId) return undefined;
    let active = true;
    let request = 0;
    const refresh = async () => {
      const current = ++request;
      try {
        const responses = await Promise.all([
          apiFetch(`/api/cases/${caseId}/appeal-entry`),
          apiFetch(`/api/cases/${caseId}/appeal-decisions`),
        ]);
        if (responses.some(response => !response.ok)) throw new Error('Appeal availability unavailable');
        const [entry, choices] = await Promise.all(responses.map(response => response.json()));
        if (active && current === request) setLoaded({ caseId, action: appealQuickAction(entry, choices) });
      } catch (_) {
        if (active && current === request) setLoaded({ caseId, action: null });
      }
    };
    refresh();
    // Another case can change this participant's one-active-appeal state.
    window.addEventListener('case-events-refresh', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      active = false;
      window.removeEventListener('case-events-refresh', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [caseId]);
  return caseId && String(loaded?.caseId) === String(caseId) ? loaded.action : null;
}
